import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

import { SetThemeCSSVariables } from './CustomTheme';

const GlobalStyle = createGlobalStyle`
  ${normalize}

  *,
  *:after,
  *:before {
    box-sizing: border-box;
  }

  h1,h2,h3,h4,h5,h6,li,ul,p,blockquote{
    margin: 0;
    padding: 0;
  }


  .modal__portal {
    z-index: 9001;
    position: fixed;
  }
  .modal__overlay {
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    padding: var(--outerGutter);

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal__window {
    max-width: 1440px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    video {
      width: 100%;
      max-width: 100%;
    }
  }

  html{
    font-size: 16px; // REMs based on 16px
    --headerHeight: 60px;
    @media ${({ theme }) => theme.custom.layouts.above_large} {
      --headerHeight: 80px;
    }
    ${SetThemeCSSVariables()};
  }
`;

export default GlobalStyle;
